import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    rcaLibraryMainWrapper: {
        width: "100%",
    },
    rcaLibraryFiltersMainWrapper: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    mainFilters: {
        width: "100%",
        paddingLeft: 0,
    },
    title: {
        flex: 1,
    },
    extraFilters: {
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing(4),
        marginBottom: "30px",
    },
    extraFiltersContent: {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    extraFiltersSearchInput: {
        gridColumn: "1 / 3",
        display: "flex",
        alignItems: "flex-end",
    },
    showCompletedCheck: {
        display: "flex",
        alignItems: "center",
    },
    select: {
        marginLeft: theme.spacing(2),
    },
    extraFiltersActions: {
        marginTop: theme.spacing(4),
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
    },
    searchBar: {
        background: "white",
        margin: "0px 20px",
        width: "30%",
        [theme.breakpoints.down("lg")]: {
            width: "40%",
        },
    },
}));
